import { useRendersCount } from "react-use";

const useIsFirstRender = () => {
  return useRendersCount() === 1;
};

export default useIsFirstRender;